'use strict';

var DataExtractCompletedController = function DataExtractCompletedController($scope, dataExtractCustomRenderers) {
  $scope.customRenderers = dataExtractCustomRenderers;
  $scope.$on('grid:beforeUpdateBoundData', function (event, data) {
    $scope.numberOfRows = data && data.length || 0;
  });
};
DataExtractCompletedController.$inject = ['$scope', 'DataExtractCustomRenderersFactory'];
module.exports = DataExtractCompletedController;